import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { LoadingIndicatorService } from '#services/shared/loading-indicator.service';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'app-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    standalone: false
})
export class LoadingIndicatorComponent implements OnInit, OnDestroy {
  spinner = faSpinner;
  size = '10x';

  blocked = false;
  header: string;
  content: string;

  private stateSub: Subscription;

  constructor(
    public loadingIndicatorSvc: LoadingIndicatorService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Read the loading state on the next macrotask (delay(0)) so a show()/hide()
    // toggle that happens during an in-progress change-detection tick is applied
    // in a fresh tick, preventing NG0100 (ExpressionChangedAfterItHasBeenChecked).
    this.stateSub = this.loadingIndicatorSvc.state$
      .pipe(delay(0))
      .subscribe(() => {
        this.blocked = this.loadingIndicatorSvc.isVisible();
        this.header = this.loadingIndicatorSvc.header;
        this.content = this.loadingIndicatorSvc.content;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.stateSub?.unsubscribe();
  }
}
